const containerCls = "_n29c1txvwm";
const imageCls = "_n29i1q08qaz";
const creditingCls = "_n29chorc0h";

export { containerCls, creditingCls, imageCls };
import "./Image.style.linaria.module.css";
//# sourceMappingURL=Image.style.js.map
